import React, { useState, useEffect } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import NavigationBar from "../../Components/NavigationBar";
import "./ApplicationManagement.css";

export default function ApplicationDates() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [rows, setRows] = useState([
    { AwardType: '', Open_Date: '', Time_1: '', Close_Date: '', Time_2: '', Year: '' },
  ]);
  const [awardTypes, setAwardTypes] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/getAwards`)
      .then((res) => res.json())
      .then((data) => {
        setAwardTypes(data); // Expects data with fields: Award_Id and Name
      })
      .catch((error) => {
        console.error('Failed to fetch award types:', error);
      });
  }, []);

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleSubmit = async (index) => {
    const { AwardType, Open_Date, Time_1, Close_Date, Time_2, Year } = rows[index];

    if (!AwardType || !Open_Date || !Time_1 || !Close_Date || !Time_2 || !Year) {
      alert('Please fill in all fields before submitting.');
      return;
    }

    const payload = {
      AwardType,
      Open_Date,
      Time_1,
      Close_Date,
      Time_2,
      Year,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/applicationdates`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      alert(result.message);

      if (result.status === "success") {
        const updatedRows = [...rows];
        updatedRows[index] = { AwardType: '', Open_Date: '', Time_1: '', Close_Date: '', Time_2: '', Year: '' };
        setRows(updatedRows);
      }
    } catch (error) {
      console.error('Upload failed', error);
      alert('Upload failed.');
    }
  };

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Application Open & Close Dates</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Award Type</th>
            <th>Application Open Date</th>
            <th>Time</th>
            <th>Application Close Date</th>
            <th>Time</th>
            <th>Year</th>
            <th>Submit</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Select
                  value={row.AwardType}
                  onChange={(e) => handleChange(index, 'AwardType', e.target.value)}
                >
                  <option value="">Select Award</option>
                  {awardTypes.map((award) => (
                    <option key={award.Award_Id} value={award.Award_Id}>
                      {award.Name}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <Form.Control
                  type="date"
                  value={row.Open_Date}
                  onChange={(e) => handleChange(index, 'Open_Date', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="time"
                  value={row.Time_1}
                  onChange={(e) => handleChange(index, 'Time_1', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="date"
                  value={row.Close_Date}
                  onChange={(e) => handleChange(index, 'Close_Date', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="time"
                  value={row.Time_2}
                  onChange={(e) => handleChange(index, 'Time_2', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  placeholder="Enter Year"
                  value={row.Year}
                  onChange={(e) => handleChange(index, 'Year', e.target.value)}
                />
              </td>
              <td>
                <Button className="view-button" onClick={() => handleSubmit(index)}>
                  Submit
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
